import {
  CIActionVerb,
  CIScreen
} from 'containers/Setting/components/RoleFormModal/customerIntelligence';

// Typed as CIScreen (the catalog's screen-key union) so a typo is a compile error rather than a
// route that silently denies every user at runtime. PLA-8815.
export const CI_SCREEN_OVERVIEW: CIScreen = 'customer_intelligence.overview';

// Every industry card hangs off its own screen's `.industry` parent grant; `useCardVisibility`
// derives that key from the card's permission key rather than importing a fixed one, so an overview
// grant can never authorise a customer360 card.

// CI grants bypass normalizeValues, so `view` never implies this verb — the CTA needs its own check.
export const GROWTH_PLANNER_ACTION: CIActionVerb = 'send_to_growth_planner';

// The action a card's grant has to carry for the card to be drawn at all.
export const VIEW_ACTION: CIActionVerb = 'view';
